import React, { createContext, useState, useContext, useEffect } from 'react';
import productsData from '../data/products.json';
import noticesData from '../data/notices.json';

const DataContext = createContext(null);

export const DataProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [notices, setNotices] = useState([]);

  useEffect(() => {
    setProducts(productsData);
    setNotices(noticesData);
  }, []);

  // Product CRUD operations
  const addProduct = (product) => {
    const newProduct = {
      ...product,
      id: `P${String(products.length + 1).padStart(3, '0')}`,
    };
    setProducts([...products, newProduct]);
    return newProduct;
  };

  const updateProduct = (id, updatedProduct) => {
    setProducts(products.map((p) => (p.id === id ? { ...p, ...updatedProduct } : p)));
  };

  const deleteProduct = (id) => {
    setProducts(products.filter((p) => p.id !== id));
  };

  const getProductById = (id) => {
    return products.find((p) => p.id === id);
  };

  // Notice CRUD operations
  const addNotice = (notice) => {
    const newNotice = {
      ...notice,
      id: `N${String(notices.length + 1).padStart(3, '0')}`,
      viewCount: 0,
      createdDate: new Date().toISOString().split('T')[0],
    };
    setNotices([...notices, newNotice]);
    return newNotice;
  };

  const updateNotice = (id, updatedNotice) => {
    setNotices(notices.map((n) => (n.id === id ? { ...n, ...updatedNotice } : n)));
  };

  const deleteNotice = (id) => {
    setNotices(notices.filter((n) => n.id !== id));
  };

  const getNoticeById = (id) => {
    return notices.find((n) => n.id === id);
  };

  const value = {
    products,
    notices,
    addProduct,
    updateProduct,
    deleteProduct,
    getProductById,
    addNotice,
    updateNotice,
    deleteNotice,
    getNoticeById,
  };

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useData = () => {
  const context = useContext(DataContext);
  if (!context) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};

export default DataContext;
